import { render, staticRenderFns } from "./LoginType.vue?vue&type=template&id=16784f42&"
import script from "./LoginType.vue?vue&type=script&lang=js&"
export * from "./LoginType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports